import { Box } from "@mui/material";
import ScopeDetail from "../_components/ScopeDetail";

interface Props {
  preview?: boolean;
}

const ScopeTwo = ({ preview }: Props) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={"12px"}>
      <ScopeDetail scopeId="Scope-2" preview={preview} />;
    </Box>
  );
};

export default ScopeTwo;
